// Live-clear Gravity Forms field errors as the user fixes them.
//
// GF only re-validates on submit (AJAX re-render), so a flagged field keeps its
// .gfield_error state + "This field is required." message even after it's fixed.
// We clear that early for the two validations we can cheaply reproduce client-side:
// required (field became non-empty) and email (now a valid address). Every other
// field type / rule is left to GF's server-side pass on submit.
//
// Delegated on document so it keeps working after GF swaps the form DOM via ajax.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function clearFieldError(field: Element): void {
  field.classList.remove("gfield_error");
  field
    .querySelectorAll(".gfield_validation_message, .validation_message")
    .forEach((el) => el.remove());
  field
    .querySelectorAll("[aria-invalid]")
    .forEach((el) => el.setAttribute("aria-invalid", "false"));
}

function maybeClear(target: EventTarget | null): void {
  if (
    !(
      target instanceof HTMLInputElement ||
      target instanceof HTMLTextAreaElement ||
      target instanceof HTMLSelectElement
    )
  ) {
    return;
  }

  const field = target.closest(".gfield.gfield_error");
  if (!field) return;

  const value = target.value.trim();
  const isEmail = target instanceof HTMLInputElement && target.type === "email";

  let fixed: boolean;
  if (isEmail) {
    // covers a required-and-empty email too: a valid address is non-empty
    fixed = EMAIL_RE.test(value);
  } else if (field.classList.contains("gfield_contains_required")) {
    fixed = value !== "";
  } else {
    return; // not a required/email error — leave it for GF to re-check on submit
  }

  if (!fixed) return;
  clearFieldError(field);

  // Drop the form-level error summary once no field errors remain.
  const wrapper = field.closest(".gform_wrapper");
  if (wrapper && !wrapper.querySelector(".gfield_error")) {
    wrapper.querySelector(".gform_validation_errors")?.remove();
  }
}

document.addEventListener("input", (e) => maybeClear(e.target));
document.addEventListener("change", (e) => maybeClear(e.target));
